"use client";
import { useEffect } from "react";
import { getMessaging, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import Notification from "./notf";

const FirebaseMessaging = () => {
  useEffect(() => {
    const firebaseConfig = {
      apiKey: process.env.NEXT_PUBLIC_FB_CLIENT_API_KEY,
      authDomain: process.env.NEXT_PUBLIC_FB_CLIENT_AUTH_DOMAIN,
      databaseURL: process.env.NEXT_PUBLIC_FB_CLIENT_DB_URL,
      projectId: process.env.NEXT_PUBLIC_FB_CLIENT_PROJECT_ID,
      storageBucket: process.env.NEXT_PUBLIC_FB_CLIENT_STORAGE,
      messagingSenderId: process.env.NEXT_PUBLIC_FB_CLIENT_MSG_SENDER,
      appId: process.env.NEXT_PUBLIC_FB_CLIENT_APP_ID,
      measurementId: process.env.NEXT_PUBLIC_FB_CLIENT_MEASURE_ID,
    };

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
      <Notification />;
    });

    // Handle messages from service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data.type === "SHOW_TOAST") {
        <Notification />;
      }
    });
  }, []);

  return null;
};

export default FirebaseMessaging;
